var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "../base";
import { FooterPoweredBy } from "./footer-powered-by";
import { FooterText } from "./footer-text";
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer(configuration) {
        var _this = _super.call(this) || this;
        _this.addLinkStyles = function (window, color) {
            window.insertAdjacentHTML('afterbegin', "\n            <style type=\"text/css\">\n                a:link {\n                    color: ".concat(color, ";\n                }\n\n                a:visited {\n                    color: ").concat(color, ";\n                }\n\n                a:hover {\n                    color: ").concat(color, ";\n                }\n\n                a:active {\n                    color: ").concat(color, ";\n                } \n            </style>\n        "));
        };
        var footer = document.createElement('div');
        footer.id = 'js_aigo_bot_footer';
        _this._footerText = new FooterText(configuration.footerText);
        _this._footerPoweredBy = new FooterPoweredBy();
        footer.style.color = configuration.footerFontColor;
        footer.style.backgroundColor = configuration.backgroundColor;
        footer.style.borderBottomLeftRadius = '5px';
        footer.style.borderBottomRightRadius = '5px';
        footer.appendChild(_this._footerText.self);
        if (configuration.isFooterPoweredByTextHidden === false) {
            footer.appendChild(_this._footerPoweredBy.self);
        }
        _this.addLinkStyles(footer, configuration.footerFontColor);
        _this.self = footer;
        return _this;
    }
    return Footer;
}(Base));
export { Footer };
